export enum EAvaliacaoFolhaTesteQuestao {
  Adequado = 1,
  ParcialmenteAdequado = 2,
  Inadequado = 3,
  NA = 4,
  InformaçõesAdicionais = 5
}

export const EAvaliacaoFolhaTesteQuestaoDescricao = {
  [EAvaliacaoFolhaTesteQuestao.Adequado]: 'Adequado',
  [EAvaliacaoFolhaTesteQuestao.ParcialmenteAdequado]: 'Parcialmente adequado',
  [EAvaliacaoFolhaTesteQuestao.Inadequado]: 'Inadequado',
  [EAvaliacaoFolhaTesteQuestao.NA]: 'N/A - Não se aplica',
  [EAvaliacaoFolhaTesteQuestao.InformaçõesAdicionais]: 'I/A – Informações adicionais'
};